module.exports = __webpack_public_path__ + "img/Proliferation-GBM_GSE194329.d284e5fd.png";